export default __webpack_public_path__ + "static/media/calendar.19fe817a.svg";